<template>
    <div>
        <Nav bgColor="#FFFFFF" />
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <span class="text-uppercase text-black  display-1 home-text mx-2 text-center">Visit</span>
            </div>
        </div>
        <div class="container pt-2">
            <div class="mx-auto text-center" style="max-width: 1000px;">
                Our main company performs two shows every Friday and Saturday night at our theater. Click here for
                directions and information on where to park. Tickets cost $11, $7 for students, educators and veterans,
                and
                can be purchased online or at the door. Reservations can be made for groups of four or more people by
                texting or calling (608) 216-5533.
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center pt-5 pb-5">
            <a :href="`${$TICKETS_URL}`">
                <div class="btn dark-btn ms-2 text-uppercase mb-5 site-black-bg text-white"
                    style="border-radius: 1; min-width: 180px;" type="button">Buy Tickets</div>
            </a>
        </div>
        <div class="bg-dark w-100 mb-5" style="height: 2px;"></div>

        <AllShows />
        <PageSections :sectionId="2" />
        <Footer />

    </div>



</template>

<script>
import PageSections from '@/components/PageSections.vue';
import AllShows from '../components/AllShows.vue';
import Footer from '../components/Footer.vue'
import Nav from "../components/Nav.vue"


export default {
    name: 'Visit',
    components: {
        Nav, Footer, AllShows, PageSections
    },

};
</script>
